import { render, staticRenderFns } from "./SingleMatchInfo.vue?vue&type=template&id=06de3704&scoped=true&"
import script from "./SingleMatchInfo.vue?vue&type=script&lang=js&"
export * from "./SingleMatchInfo.vue?vue&type=script&lang=js&"
import style0 from "./SingleMatchInfo.vue?vue&type=style&index=0&id=06de3704&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06de3704",
  null
  
)

export default component.exports